export enum StoreTypes {
  ADRequests = 'AD Requests',
  Administrators = 'Administrators',
  AlertsHistory = 'Alerts History',
  Application = 'Application',
  Auth = 'Authentication',
  BackupHistory = 'Backup History',
  CapacityReport = 'CapacityReport',
  Companies = 'Companies',
  Computers = 'Computers',
  ComputersBackup = 'Computers Backup',
  ComputersPaging = 'Computers Paging',
  ComputersStatistic = 'Computers Statistic',
  CustomDnsBinding = 'Custom DNS Bindings',
  Domains = 'Domains',
  GroupAction = 'Group Action Tasks',
  Licenses = 'Licenses',
  RmmGroupActionWizard = 'RMM Group Action Wizard',
  RmmScriptLibrary = 'RMM Script Library',
  RmmCustomAlertSettings = 'RMM Custom Alerting Settings',
  Snmp = 'SNMP Devices',
  SnmpAlerts = 'SNMP Alerting',
  SnmpOId = 'SNMP Oid Devices',
  TFA = 'TFA',
  Users = 'Users'
}
